import { Component, OnInit, ViewEncapsulation, Inject, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
// Import the locale files
import { locale as english } from './i18n/en';
import { locale as spanish } from './i18n/es';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Router } from '@angular/router';
import { DataManagement } from 'app/services/dataManagement';
import { Credenciales } from 'app/models/form.model';
import { DialogModule } from 'app/dialogs/dialog/dialog.module';
import { UtilityProvider } from 'app/providers/utility/utility';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ScrumboardCardDialogComponent } from 'app/main/apps/scrumboard/board/dialogs/card/card.component';
import { ScrumboardService } from 'app/main/apps/scrumboard/scrumboard.service';
import { GlobalService } from 'app/services/globalService';
import { Cookies, Cliente } from 'app/models/data.model';
import { ActivatedRoute } from '@angular/router';
import { RestWS } from 'app/services/restService'

@Component({
    selector: 'document-verify',
    templateUrl: './document-verify.component.html',
    styleUrls: ['./document-verify.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DocumentVerifyComponent implements OnInit {

    sesionActiva: boolean;
    files: any;
    archivo: any;
    fileName: string;

    verifyForm: FormGroup;
    loading: boolean;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    cookies: Cookies;
    verificationStatus: string;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        private router: Router,
        private dm: DataManagement,
        private utils: UtilityProvider,
        private globalService: GlobalService,
        private route: ActivatedRoute,
        private api: RestWS,
        private renderer: Renderer2
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        this.translationLoader.loadTranslations(english, spanish);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.loading = true;
        this.verificationStatus = "esperando";

        this.globalService.leerCookies().then(res => {
            if (res) {
                this.sesionActiva = true;
            }
            this.verifyForm = this._formBuilder.group({
                archivo: ['', [Validators.required]],
                identifier: ['', Validators.required]
            });
            this.loading = false;
            this.cookies = new Cookies();
        });

    }


    dataURLtoFile(dataurl, filename) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    eventHandler(event) {
        if (this.archivo && this.verifyForm.get('identifier').value && event.keyCode == 13) {
            this.verify();
        }
    }


    onFileSelected(event) {
        this.files = event.target.files;
        if (this.files.length > 0) {
            this.archivo = this.files[0];
            this.fileName = this.files[0].name;
        }
    }

    volverAVerificar() {
        this.verificationStatus = "esperando";
    }

    async verify() {
        this.loading = true;
        try {
            let identificador = this.verifyForm.get('identifier').value;
            let resVerificar = await this.dm.verificarDocumentoDeEvento(identificador, this.archivo);
            if (!resVerificar) {
                await this.utils.openDialog(this.utils.ERROR, "Ha ocurrido un error, inténtelo de nuevo", false, false);
                this.loading = false;
            } else if (resVerificar.status == 'bad') {
                switch (resVerificar.code) {
                    case 11:
                        await this.utils.openDialog(this.utils.WARNING, "El identificador es obligatorio para poder realizar la verificación", false, false);
                        break;

                    case 21:
                        await this.utils.openDialog(this.utils.WARNING, "El fichero es obligatorio para poder realizar la verificación", false, false);
                        break;

                    case 22:
                        await this.utils.openDialog(this.utils.WARNING, "El fichero es obligatorio para poder realizar la verificación", false, false);
                        break;

                    case 23:
                        await this.utils.openDialog(this.utils.WARNING, "El fichero debe ser PDF", false, false);
                        break;

                    default:
                        await this.utils.openDialog(this.utils.WARNING, "Los datos introducidos no coinciden", false, false);
                        break;
                }
                this.loading = false;
            } else if (resVerificar.status == 'ok') {
                //Comprobamos que el cliente puede acceder al panel de control
                //Restringimos uso de panel a clientes con proveedor asociado
                if (!resVerificar.result) {
                    this.verificationStatus = "no_verificado";
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.verificationStatus = "verificado";
                }
            }
        } catch (error) {
            //console.log(error);
            await this.utils.openDialog(this.utils.ERROR, "Ha ocurrido un error, revise su conexión a internet", false, false);
            this.loading = false;
        }
    }

}
